import { plainToClass } from 'class-transformer';
import { reservationHttp } from './http';
import { ReservationInfoModel } from 'models';
import { isApiError, BasketApiErrorModel } from 'models/Errors';
import { errorToBasketErrorModel } from 'helpers';

export class ReservationRepository {
    public async getReservationInfo(basketId: string): Promise<ReservationInfoModel> {
        try {
            const response = await reservationHttp.get(`/${basketId}`);

            return plainToClass(ReservationInfoModel, response.data);
        } catch (error) {
            const errorSource = 'reservation.repository:getReservationInfo';
            if (isApiError(error)) {
                throw new BasketApiErrorModel(error, errorSource);
            } else {
                throw errorToBasketErrorModel(error, errorSource);
            }
        }
    }
}

export const reservation = new ReservationRepository();